
export class VehicleRequest{
    
    vehicleReqCode?:string
    extNo?:string
    vehicleRequiredOn?:string
    role?:string

    constructor(
        
       vehicleReqCode?:string,    
       extNo?:string,
       vehicleRequiredOn?:string,
       role?:string


    ){
        
        this.vehicleReqCode=vehicleReqCode
        this.extNo = extNo,
        this.vehicleRequiredOn=vehicleRequiredOn
        this.role=role

    }
}